// extracted by mini-css-extract-plugin
export default {"userContainer":"ManagerName_userContainer__b21zo","icon":"ManagerName_icon__75C27","iconArrow":"ManagerName_iconArrow__+Ze5J","modalUser":"ManagerName_modalUser__YXKra"};